<template>
  <v-sheet rounded :color="color" :dark="dark">
    <v-list-item>
      <v-list-item-action v-if="radioValue">
        <v-radio :value="radioValue" />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="text-truncate" v-if="canReadCompany" @click="goToDetail">
          <a>{{ company.companyName }}</a>
        </v-list-item-title>
        <v-list-item-title v-else class="text-truncate">
          {{ company.companyName }}
        </v-list-item-title>
        <v-list-item-subtitle class="text-xs text-truncate mb-2">
          <span v-if="company.services">
            <v-chip x-small v-for="service of company.services" :key="'service-enum' + service" class="mr-1">
              {{ $t(`enums.CompanyServiceEnum.${service}`) }}
            </v-chip>
          </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="company.addresses.length && !hideDetails" class="text-truncate">
          {{ company.addresses[0].street }}, {{ company.addresses[0].zip }}
          {{ company.addresses[0].city }}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="company.contact && !hideDetails" class="text-truncate">
          {{ company.contact.email }}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="company.contact && !hideDetails" class="text-truncate">
          {{ company.contact.phone }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="clearable && canUpdateCompany">
        <v-btn icon @click="clear">
          <v-icon> mdi-trash-can-outline </v-icon>
        </v-btn>
        <div></div>
      </v-list-item-action>
    </v-list-item>
    <slot></slot>
  </v-sheet>
</template>

<script lang="ts">
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ICompany } from "@/models/company.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class CompanySheet extends mixins(PermissionMixin) {
  @Prop()
  company!: ICompany;

  @Prop({ default: "grey lighten-4" })
  color!: string;

  @Prop({ type: Boolean, default: false })
  dark!: boolean;

  @Prop({ default: false, type: Boolean })
  clearable!: boolean;

  @Prop()
  radioValue!: string;

  @Prop({ default: false, type: Boolean })
  hideDetails!: boolean;

  goToDetail() {
    if (this.canReadCompany) {
      this.company.goTo(this.$router).detail();
    }
  }

  clear() {
    this.$emit("clear", this.company);
  }
}
</script>
